export const CRM_INCREMENT_VERSION = 'CRM_INCREMENTAL_OCT_2026_V1';
//# sourceMappingURL=member-crm-increment.js.map